import React from 'react'

const BottomSpacer = () => {
  return (
    <div className='w-full h-40 bg-gradient-to-b from-gray-800 to-black'>
    </div>
  )
}

export default BottomSpacer